
import React from 'react'
import ExternalLogin from '../components/external_login/View'
const LoginPage = (props) => {

    const {
        classes,
        isLogging,
        onSignIn,
        onExternalSubmit,
        onForgotPasswordClick,
        isEmailNotVerifiedYet,
        messageText,
        messageType,
        resetAuthMessageBox,
        onSendMeActivationEmailClick,
        // ssoLoginStarted,
        account, onSSOSubmit, ssoLoginError, error,
      } = props

  return (
    <div>
         {/* {showExternalLogin && ( */}
          <ExternalLogin
            // openDialog={showExternalLogin}
            isLogging={isLogging}
            // closeDialog={() => setShowExternalLogin(false)}
            forgotPassword={onForgotPasswordClick}
            onExternalSubmit={onExternalSubmit}
            isEmailNotVerifiedYet={isEmailNotVerifiedYet}
            messageText={messageText}
            messageType={messageType}
            onSendMeActivationEmailClick={onSendMeActivationEmailClick}
            resetAuthMessageBox={resetAuthMessageBox}
          />
        {/* )} */}
    </div>
  )
}

export default LoginPage